module.exports = __webpack_public_path__ + "r-v3/img/sticker_15.afa0fba4.svg";